import { types, NAME } from './reducer'
import { RSAA } from 'redux-api-middleware'
import entryPoint from '../../constants/endpoints'
import {actions as mainActions } from '../Root/actions'

export const actions = {
  getRevenue: (data) => dispatch => dispatch({

  }),
  editMonitorAction: (value) => (dispatch, getState) => {
    let thisState = getState()[NAME]
    let selected = thisState.monitorsList.find((element, index, array) => {
      return element.id === value.selected
    })  
    return dispatch({
      type: types.EDIT_MONITOR_ACTION,   
      selected: selected,   
      showEdit: value.showEdit
    })
  },
  getMonitorsList: () => ({
    [RSAA]: {
      types: [
        {
          type: types.MONITORS_LIST_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.MONITORS_LIST_SUCCESS,
          payload: (action, state, res) => res.json()
            .then((data) => {
              return data
            })
        },
        {
          type: types.MONITORS_LIST_FAILURE,
          payload: (action, state, res) => {
            return
          }

        }
      ],
      endpoint: `${entryPoint}/monitorsList`,
      credentials: 'include',
      method: 'GET'
    }
  }),
  getWarehouseProducts: (warehouse_id) => ({ // New action for warehouseproducts
    [RSAA]: {
      types: [
        {
          type: types.WAREHOUSE_PRODUCTS_REQUEST,
          payload: () => {}
        },
        {
          type: types.WAREHOUSE_PRODUCTS_SUCCESS,
          payload: (action, state, res) => res.json()
            .then((data) => {
              return { warehouse_id, products: data };
            })
        },
        {
          type: types.WAREHOUSE_PRODUCTS_FAILURE,
          payload: () => {}
        }
      ],
      endpoint: `${entryPoint}/warehouseproducts/${warehouse_id}`,
      credentials: 'include',
      method: 'GET'
    }
  }),
  getWarehouseProductsList: () => ({ // A temporary method, will be merged with GetBalance in future
    [RSAA]: {
      types: [
        {
          type: types.WAREHOUSE_PRODUCTS_LIST_REQUEST,
          payload: (action, state, res) => {
            return;
          }
        },
        {
          type: types.WAREHOUSE_PRODUCTS_LIST_SUCCESS,
          payload: (action, state, res) => res.json()
            .then((data) => {
              return data;
            })
        },
        {
          type: types.WAREHOUSE_PRODUCTS_LIST_FAILURE,
          payload: (action, state, res) => {
            return;
          }
        }
      ],
      endpoint: `${entryPoint}/warehouseproducts`,
      credentials: 'include',
      method: 'GET'
    }
  }),
  createMonitor: (data) => dispatch => dispatch({
    [RSAA]: {
      types: [
        {
          type: types.MONITOR_CREATE_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.MONITOR_CREATE_SUCCESS,
          payload: (action, state, res) => res.json()
            .then(( data ) => {
              dispatch(mainActions.redirectTo('/listmonitor'))
              // Блок последних складов в меню показывает и новый склад.
              dispatch(actions.getMonitorsList())
              return
            })
        },
        {
          type: types.MONITOR_CREATE_FAILURE,
          payload: (action, state, res) => {
            return
          }
        }
      ],
      endpoint: `${entryPoint}/createmonitor`,
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json'}
    }
  }),
  editMonitor: (data) => dispatch => dispatch({
    [RSAA]: {
      types: [
        {
          type: types.MONITOR_EDIT_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.MONITOR_EDIT_SUCCESS,
          payload: (action, state, res) => res.json()
            .then(({ responceData }) => {
              dispatch(mainActions.redirectTo('/listmonitor'))
              // Блок последних складов в меню показывает изменение сразу.
              dispatch(actions.getMonitorsList())
              return {showEdit: false}
            })
        },
        {
          type: types.MONITOR_EDIT_FAILURE,
          payload: (action, state, res) => {
            return
          }
        }
      ],
      endpoint: `${entryPoint}/editmonitor`,
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json'}
    }
  }),
  deleteMonitor: (data) => dispatch => dispatch({
    [RSAA]: {
      types: [
        {
          type: types.MONITOR_DELETE_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.MONITOR_DELETE_SUCCESS,
          payload: (action, state, res) => res.json()
            .then(({ responceData }) => {
              dispatch(mainActions.redirectTo('/listmonitor'))
              // Блок последних складов в меню показывает изменение сразу.
              dispatch(actions.getMonitorsList())
              return {showEdit: false}
            })
        },
        {
          type: types.MONITOR_DELETE_FAILURE,
          payload: (action, state, res) => {
            return
          }
        }
      ],
      endpoint: `${entryPoint}/deletemonitor`,
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json'}
    }
  }),
  getProductTypeList: () => ({
    [RSAA]: {
      types: [
        {
          type: types.PRODUCT_TYPE_LIST_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.PRODUCT_TYPE_LIST_SUCCESS,
          payload: (action, state, res) => res.json()
            .then((data) => {
              return data
            })
        },
        {
          type: types.PRODUCT_TYPE_LIST_FAILURE,
          payload: (action, state, res) => {
            return
          }

        }
      ],
      endpoint: `${entryPoint}/producttypes`,
      credentials: 'include',
      method: 'GET'
    }
  }),
}
